export const useCreateBannerCardDefaultValues = () => ({
  type_id: null,
  app_type: null,
  activity_id: null,
  priority: null,
  status: null,
  contents: [
    {
      language_id: 1,
      title: '',
      description: '',
      image: '',
    },
    {
      language_id: 2,
      title: '',
      description: '',
      image: '',
    },
    {
      language_id: 3,
      title: '',
      description: '',
      image: '',
    },
    {
      language_id: 4,
      title: '',
      description: '',
      image: '',
    },
    {
      language_id: 5,
      title: '',
      description: '',
      image: '',
    },
  ],
  action_buttons: [],
});
